
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_784_12583)","fill":"currentColor"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.905 5.82C8.15 5.82 9.16 4.8 9.16 3.54c0-1.26-1.01-2.282-2.255-2.282-1.246 0-2.256 1.022-2.256 2.281 0 1.26 1.01 2.281 2.256 2.281zm0 1.259c1.933 0 3.5-1.585 3.5-3.54C10.405 1.585 8.838 0 6.905 0s-3.5 1.585-3.5 3.54c0 1.954 1.567 3.539 3.5 3.539z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.804 7.708c-2.508 0-4.633 1.505-5.486 3.601-.145.357-.066.681.166.947.246.281.666.486 1.143.486h4.097c.344 0 .622.281.622.629 0 .347-.278.629-.622.629H2.627c-.812 0-1.58-.343-2.076-.91-.51-.584-.729-1.41-.384-2.26 1.048-2.576 3.634-4.38 6.637-4.38 1.102 0 2.149.243 3.083.678.313.146.449.52.305.835a.62.62 0 01-.825.308 6.054 6.054 0 00-2.563-.563z"}}),_c('path',{attrs:{"d":"M13.825 8.038a.566.566 0 00-.42-.173.597.597 0 00-.42.173L9.703 11.35l-1.144-1.156a.597.597 0 00-.84 0 .612.612 0 000 .858l1.564 1.58a.598.598 0 00.84 0l3.702-3.743a.613.613 0 000-.858v.008z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_784_12583"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    